import ReminderCardView from './reminder-card-view';

export default ReminderCardView;
